<section class="tw-relative">
  <span
    class="-tw-top-2.5 tw-absolute tw-left-3.5 tw-z-[1] tw-rounded-[3px] tw-bg-white tw-px-[5px] tw-font-inter tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-500 tw-outline-none focus-visible:tw-shadow-[0_0_0_2px_rgba(28,100,242,0.2)]"
    contenteditable="true"
    role="textbox"
    [attr.aria-label]="'Edit ' + field().label + ' label'"
    (input)="onLabelInput($event)"
    >{{ field().label }}</span
  >
  <div
    class="tw-flex tw-min-h-[60px] tw-items-center tw-gap-2 tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-p-3 tw-font-inter tw-text-sm tw-leading-5 tw-text-gray-500"
  >
    <i [class]="iconClass() + ' !tw-h-4 !tw-w-4 !tw-shrink-0 !tw-grow-0 !tw-basis-4'" aria-hidden="true"></i>
    <span
      class="tw-min-w-0 tw-flex-1 tw-cursor-text tw-outline-none focus-visible:tw-rounded-[3px] focus-visible:tw-shadow-[0_0_0_2px_rgba(28,100,242,0.2)]"
      contenteditable="true"
      role="textbox"
      [attr.aria-label]="'Edit ' + field().label + ' placeholder'"
      (input)="onPlaceholderInput($event)"
      >{{ placeholder() }}</span
    >
  </div>
</section>
